import React, { useEffect, useState } from 'react';
import { fetchOnlyVigilantApi, fetchYardsApi, ListarAsignaciones } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import ListadoRondasPorAsignacion from '../../components/Reports/ListadoRondasPorAsignacion';
import { Cargando } from '../../components/Cargando';
import { peDate, parseApiError } from '../../util/util';

export default function ReporteRondas() {
  const { token } = useAuth();

  const [vigilante, setVigilante] = useState('');
  const [patio, setPatio] = useState('');
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [vigiantArry, setVigiantArry] = useState([]);
  const [patioArry, setPatioArry] = useState([]);
  const [asignaciones, setAsignaciones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [openRow, setOpenRow] = useState(null);
  const [searchParams, setSearchParams] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const [users, yards] = await Promise.all([
          fetchOnlyVigilantApi({ token }),
          fetchYardsApi({ token }),
        ]);
        setVigiantArry(users || []);
        setPatioArry((yards || []).sort((a, b) => a.nombre.localeCompare(b.nombre)));
      } catch (err) {
        console.error(err);
        setErrorMsg('No se pudieron cargar vigilantes/patios.');
      }
    })();
  }, [token]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setAsignaciones([]);
    setOpenRow(null);
    setSearchParams(null);

    // if (!vigilante || !patio || !fechaInicio || !fechaFin) {
    //   setErrorMsg('Selecciona vigilante, patio y rango de fechas.');
    //   return;
    // }
    if (!vigilante) return setErrorMsg("Seleccione un vigilante");
    if (!patio) return setErrorMsg("Seleccione un patio");
    if (!fechaInicio) return setErrorMsg("Seleccione una fecha de inicio");
    if (!fechaFin) return setErrorMsg("Seleccione una fecha de fin");

    setLoading(true);
    try {
      const dataAsignaciones = await ListarAsignaciones({
        startDate: fechaInicio,
        endDate: fechaFin,
        userId: vigilante,
        yardId: patio || undefined,
        token,
      });
      console.log(dataAsignaciones)
      const normalizedAssignments = Array.isArray(dataAsignaciones) ? dataAsignaciones : [];
      setAsignaciones(normalizedAssignments);
      setSearchParams({
        startDate: fechaInicio,
        endDate: fechaFin,
        userId: vigilante,
      });
    } catch (err) {
      console.error(err);
      setAsignaciones([]);
      setSearchParams(null);
      setErrorMsg(parseApiError(err, 'No se pudo listar las asignaciones.'));
    } finally {
      setLoading(false);
    }
  };

  const VerListadoRondas = (assignmentId) => {
    setOpenRow((prev) => (prev === assignmentId ? null : assignmentId));
  };

  return (
    <div className="container-fluid">
      <h4 className="mb-3">Historial de Rondas</h4>
      <div className="card">
        <div className="card-body">
          <form onSubmit={onSubmit}>
            <div className="row g-3 align-items-end">
              <div className="col-12 col-md-6">
                <label className="form-label">Vigilante</label>
                <select className="form-select" value={vigilante} onChange={(e) => setVigilante(e.target.value)}>
                  <option value="">-- Selecciona --</option>
                  {vigiantArry.map((v) => (
                    <option key={v.id} value={v.id}>
                      {v.nombres} {v.apellidos}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label">Patio</label>
                <select className="form-select" value={patio} onChange={(e) => setPatio(e.target.value)}>
                  <option value="">-- Todos --</option>
                  {patioArry.map((p) => (
                    <option key={p.id} value={p.id}>{p.nombre}</option>
                  ))}
                </select>
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label">Fecha de inicio</label>
                <input
                  type="date"
                  className="form-control"
                  value={fechaInicio}
                  onChange={(e) => setFechaInicio(e.target.value)}
                />
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label">Fecha de fin</label>
                <input
                  type="date"
                  className="form-control"
                  value={fechaFin}
                  onChange={(e) => setFechaFin(e.target.value)}
                />
              </div>

              <div className="col-12 col-md-4">
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Buscando...' : 'Buscar'}
                </button>
              </div>
            </div>
          </form>

          {errorMsg && <div className="alert alert-danger mt-3">{errorMsg}</div>}

          <div className="mt-3">
            {loading && (
              <div className="py-4 text-center border rounded">
                <Cargando />
              </div>
            )}

            {!loading && asignaciones.length === 0 && !errorMsg && (
              <div className="text-center py-4 border rounded">Sin resultados</div>
            )}

            {!loading && asignaciones.length > 0 && searchParams && (
              <div className="accordion" id="accordionAsignaciones">
                {asignaciones.map((a, index) => {
                  const isOpen = openRow === a.assignmentId;
                  const collapseId = 'assignment-' + index;
                  const headingId = 'heading-' + collapseId;
                  const label =  'Turno ' + (index + 1) ;

                  return (
                    <div className="accordion-item" key={a.assignmentId}>
                      <h2 className="accordion-header" id={headingId} >
                        <button
                          type="button"
                          className={'accordion-button' + (isOpen ? '' : ' collapsed')}
                          onClick={() => VerListadoRondas(a.assignmentId)}
                          aria-expanded={isOpen}
                          aria-controls={collapseId}
                        >
                          {label} 🕑 {a.initHourShift.slice(0, 5)} - {a.endHourShift.slice(0, 5)} 📆 {peDate(a.initDatePlanning)} - {peDate(a.endDatePlanning)}
                        </button>
                      </h2>
                      <div
                        id={collapseId}
                        className={'accordion-collapse collapse' + (isOpen ? ' show' : '')}
                        aria-labelledby={headingId}
                        data-bs-parent="#accordionAsignaciones"
                      >
                        <div className="accordion-body">
                          <ListadoRondasPorAsignacion
                            assignment={a}
                            assignmentId={a.assignmentId}
                            startDate={searchParams.startDate}
                            endDate={searchParams.endDate}
                            userId={searchParams.userId}
                            token={token}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}
